/* VINTAGE SCUBA — product page: gallery, variants, AJAX add-to-cart (opens the cart drawer),
   sticky bar, zoom, share. Lightweight, no dependencies. */
import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => [...c.querySelectorAll(s)];

function money(cents) {
  const f = (window.VS && window.VS.money) || '₹{{amount}}';
  const n = cents / 100;
  const whole = Math.round(n) === n;
  const amt = whole ? n.toLocaleString('en-IN') : n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (k.includes('no_decimals') ? Math.round(n).toLocaleString('en-IN') : amt));
}

function init(root) {
  if (root.__vsPdp) return;
  root.__vsPdp = true;
  document.body.dataset.template = 'product';

  const form = $('[data-vs-form]', root);
  const idInput = $('[data-vs-id]', root);
  const atc = $('[data-vs-atc]', root);
  const atcText = $('[data-atc-text]', root);
  const err = $('[data-vs-error]', root);
  const sticky = $('[data-vs-sticky]', root);
  const stickyBtn = $('[data-vs-sticky-atc]', root);
  const stickyText = $('[data-sticky-text]', root);
  const stickyPrice = $('[data-sticky-price]', root);
  const soldLabel = root.dataset.soldLabel || 'Sold Out';
  let variants = [];
  try { variants = JSON.parse($('[data-vs-variants]', root).textContent); } catch (e) {}
  const fieldsets = $$('.vs-pdp__opt', root);

  /* ---------- gallery ---------- */
  const slider = $('[data-vs-slider]', root);
  if (slider) {
    const slides = $$('[data-slide]', slider);
    const thumbs = $$('[data-thumb]', root);
    const count = $('[data-vs-count]', root);
    let idx = 0, raf = 0;
    const pad = (n) => String(n).padStart(2, '0');
    const sync = () => {
      raf = 0;
      const w = slider.clientWidth || 1;
      const i = Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / (slides[0].offsetWidth + 10 || w))));
      if (i === idx) return;
      idx = i;
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
      if (count) count.textContent = `${pad(i + 1)} / ${pad(slides.length)}`;
      const th = thumbs[i]; if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };
    slider.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
    const go = (i) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      slider.scrollTo({ left: slides[i].offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.thumb)));
    $('[data-vs-prev]', root)?.addEventListener('click', () => go(idx - 1));
    $('[data-vs-next]', root)?.addEventListener('click', () => go(idx + 1));
    root.__vsGo = (imageId) => {
      const i = slides.findIndex((s) => String(s.dataset.imageId) === String(imageId));
      if (i > -1) go(i);
    };

    // zoom
    const box = $('[data-vs-lightbox]', root);
    if (box) {
      const img = $('[data-lightbox-img]', box);
      slider.addEventListener('click', (e) => {
        const z = e.target.closest('[data-zoom]'); if (!z) return;
        img.src = z.dataset.zoom; box.showModal();
      });
      box.addEventListener('click', () => box.close());
    }
  }

  /* ---------- variants ---------- */
  const selected = () => fieldsets.map((f) => ($('input:checked', f) || {}).value);
  const current = () => {
    if (!fieldsets.length) return variants[0];
    const s = selected();
    return variants.find((v) => v.options.every((o, i) => o === s[i]));
  };

  function paintAvailability() {
    const s = selected();
    fieldsets.forEach((f, i) => {
      $$('.vs-pill', f).forEach((p) => {
        const val = $('input', p).value;
        const ok = variants.some((v) => v.available && v.options[i] === val && v.options.every((o, k) => k === i || o === s[k]));
        p.classList.toggle('is-oos', !ok);
      });
    });
  }

  function apply(first) {
    const v = current();
    paintAvailability();
    fieldsets.forEach((f) => { const c = $('input:checked', f); const l = $('[data-opt-label]', f); if (c && l) l.textContent = c.value; });
    if (!v) {
      // combination doesn't exist
      if (atc) { atc.disabled = true; atcText.textContent = 'Unavailable'; }
      if (stickyBtn) { stickyBtn.disabled = true; stickyText.textContent = 'Unavailable'; }
      return;
    }
    idInput.value = v.id;
    const now = $('[data-price-now]', root), was = $('[data-price-was]', root), off = $('[data-price-off]', root);
    if (now) now.textContent = money(v.price);
    const sale = v.compare > v.price;
    if (was) { was.hidden = !sale; was.textContent = sale ? money(v.compare) : ''; }
    if (off) { off.hidden = !sale; off.textContent = sale ? Math.round(((v.compare - v.price) * 100) / v.compare) + '% Off' : ''; }
    if (stickyPrice) stickyPrice.textContent = money(v.price);

    const label = v.available ? 'Add To Cart' : soldLabel;
    [[atc, atcText], [stickyBtn, stickyText]].forEach(([b, t]) => { if (b) { b.disabled = !v.available; b.classList.remove('is-busy'); } if (t) t.textContent = label; });

    if (!first) {
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.image && root.__vsGo) root.__vsGo(v.image);
    }
    // lets the shared helpers (stock text, WhatsApp button) refresh
    document.dispatchEvent(new CustomEvent('variant:update'));
  }
  fieldsets.forEach((f) => f.addEventListener('change', () => apply(false)));
  apply(true);

  /* ---------- add to cart ---------- */
  let busy = false;
  const showError = (msg) => { if (!err) return; err.textContent = msg; err.hidden = false; setTimeout(() => (err.hidden = true), 8000); };

  async function add(e) {
    e && e.preventDefault();
    const v = current();
    if (busy || !v || !v.available) return;
    busy = true; err && (err.hidden = true);
    [atc, stickyBtn].forEach((b) => b && b.classList.add('is-busy'));
    if (atcText) atcText.textContent = 'Adding…';
    if (stickyText) stickyText.textContent = 'Adding…';

    const fd = new FormData();
    fd.append('id', v.id); fd.append('quantity', '1'); fd.append('form_type', 'product'); fd.append('utf8', '✓');
    const sectionIds = [...new Set($$('cart-items-component').map((el) => el.dataset.sectionId).filter(Boolean))];
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));

    try {
      const cfg = fetchConfig('javascript', { body: fd });
      const res = await fetch(Theme.routes.cart_add_url, { ...cfg, headers: { ...cfg.headers, Accept: 'text/html' } });
      const json = await res.json();
      if (json.status) {
        showError(json.description || json.message || 'Could not add this item.');
        flash('Add To Cart', false);
      } else {
        const cart = await fetch('/cart.js').then((r) => r.json()).catch(() => undefined);
        form.dispatchEvent(new CartAddEvent(cart, String(v.id), {
          source: 'product-form-component', itemCount: 1, productId: root.dataset.productId, sections: json.sections,
        }));
        flash('Added ✓', true);
      }
    } catch (x) {
      console.error(x); showError('Something went wrong. Please try again.'); flash('Add To Cart', false);
    }
  }
  function flash(text, ok) {
    if (atcText) atcText.textContent = text;
    if (stickyText) stickyText.textContent = text;
    [atc, stickyBtn].forEach((b) => b && b.classList.remove('is-busy'));
    setTimeout(() => { busy = false; apply(true); }, ok ? 1500 : 200);
  }
  form.addEventListener('submit', add);
  stickyBtn && stickyBtn.addEventListener('click', () => form.requestSubmit());

  /* ---------- sticky bar (phones/tablets) ---------- */
  const buy = $('[data-vs-buy]', root);
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', String(!show));
    }, { threshold: 0 }).observe(buy);
  }

  /* ---------- share ---------- */
  const share = $('[data-vs-share]', root);
  share && share.addEventListener('click', async () => {
    const url = share.dataset.vsShare, title = share.dataset.title;
    try {
      if (navigator.share) await navigator.share({ title, url });
      else { await navigator.clipboard.writeText(url); const s = $('span', share); const o = s.textContent; s.textContent = 'Link Copied'; setTimeout(() => (s.textContent = o), 1600); }
    } catch (x) { /* dismissed */ }
  });
}

const boot = () => $$('[data-vs-pdp]').forEach(init);
boot();
document.addEventListener('shopify:section:load', boot);
